import API, {AuthorizeInterceptor} from "@crunchyroll/cx-api-client-lite";

import Auth from "./services/Auth";
import Talkbox from "./services/Talkbox";
import Account from "./services/Account";
import Content from "./services/Content";
import Subscription from "./services/Subscription";
import News from "./services/News";
import countryOverrideInterceptor from "./interceptors/countryOverrideInterceptor";
import stringifyParams from "./interceptors/stringifyParamsInterceptor";
import {cxApiParams} from "../../config";
import {getAccessToken} from "./requests/token";
import clientLocaleInterceptor from "./interceptors/clientLocaleInterceptor";

AuthorizeInterceptor.onTokenExpire(getAccessToken);

API.defaultConfig.updateConfig({
  baseURL: cxApiParams.host,
});

API.Auth = Auth;
API.Talkbox = Talkbox;
API.Account = Account;
API.Subscription = Subscription;
API.Content = Content;
API.News = News;

Content.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());
Talkbox.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());
Account.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());
Subscription.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());
News.addRequestInterceptor(AuthorizeInterceptor.getInterceptor());
Auth.addRequestInterceptor(countryOverrideInterceptor.getInterceptor());
Talkbox.addRequestInterceptor(clientLocaleInterceptor.getInterceptor());
News.addRequestInterceptor(stringifyParams);

export default API;
